import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信用信息
 */
export class CreditInformationController {
    constructor() {
        this.baseurl = 'CreditInformationController.assx/';
    }

    /**
     * 获取共管资金账户详情
     * eaAreaCode:String, type:int
     */
    GetCommonAccountByEaAreaCode(eaAreaCode, type){
        return request.post(this.baseurl + 'GetCommonAccountByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode, type:type }));
    }

    /**
     * 获取主任良好或不良好信息列表
     * name:String, eaAreaName:String, type:int, startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBehaviorListByDirector(name, eaAreaName, type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorListByDirector', Qs.stringify({ name:name, eaAreaName:eaAreaName, type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 获取项目经理基础信息详情
     * uniqId:String
     */
    GetManageBaseInfo(uniqId){
        return request.post(this.baseurl + 'GetManageBaseInfo', Qs.stringify({ uniqId:uniqId }));
    }

    /**
     * 获取成员良好或不良好信息详情
     * name:String, eaAreaCode:String, type:int
     */
    GetBehaviorDetailByMember(name, eaAreaCode, type){
      return request.post(this.baseurl + 'GetBehaviorDetailByMember', Qs.stringify({ name:name, eaAreaCode:eaAreaCode, type:type }));
    }

    /**
     * 获取业委会监事良好或不良好信息详情
     * keyID:String, type:int
     */
    GetBehaviorDetailBySupervisor(keyID, type){
        return request.post(this.baseurl + 'GetBehaviorDetailBySupervisor', Qs.stringify({ keyID:keyID, type:type }));
    }
    
    /**
     * 获取负责人良好信息列表
     * orgName:String, type:int, startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBehaviorListByManger(orgName, type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorListByManger', Qs.stringify({ orgName:orgName, type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 信息公开列表（物业区域一级）
     * para:ReprotFillQueryPara, year:String, type:int, startIndex:int, maxSize:int
     */
    GetPublicReportFillListByEaAreaDetail(para, year, type, startIndex, maxSize){
        return request.post(this.baseurl + 'GetPublicReportFillListByEaAreaDetail', Qs.stringify({ para:typeof para === 'undefined' || para === null ? '' : para.toString(), year:year, type:type, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取业委会监事基础信息详情
     * eaAreaCode:String, peopleName:String
     */
    GetBasicDetailBySupervisor(eaAreaCode, peopleName){
        return request.post(this.baseurl + 'GetBasicDetailBySupervisor', Qs.stringify({ eaAreaCode:eaAreaCode, peopleName:peopleName }));
    }

    /**
     * 获取共管账户详情列表
     * orgCode:String, eaAreaCode:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetCommonAccountListByEaAreaCodeOrOrgName(orgCode, eaAreaCode, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetCommonAccountListByEaAreaCodeOrOrgName', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取业委会秘书基础信息详情列表
     * startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBasicListBySecretary(startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBasicListBySecretary', Qs.stringify({ startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 培训人员列表
     * orgCode:String, eaAreaName:String, name:String, phoneNum:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetTrainResultListByEaAreaNameOrOrgName(orgCode, eaAreaName, name, phoneNum, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetTrainResultListByEaAreaNameOrOrgName', Qs.stringify({ orgCode:orgCode, eaAreaName:eaAreaName, name:name, phoneNum:phoneNum, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取不良好行为列表
     * eaAreaCode:String, orgCode:String, name:String, iDCard:String, type:int, option:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    getBadBehaviorListByDetail(eaAreaCode, orgCode, name, iDCard, type, option, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'getBadBehaviorListByDetail', Qs.stringify({ eaAreaCode:eaAreaCode, orgCode:orgCode, name:name, iDCard:iDCard, type:type, option:option, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 物业企业小区评价情况
     * orgCode:String, eaAreaCode:String, startIndex:int, maxSize:int, type:Integer
     */
    GetCreditInfoOfEaAreaEvaList(orgCode, eaAreaCode, startIndex, maxSize, type){
        return request.post(this.baseurl + 'GetCreditInfoOfEaAreaEvaList', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, startIndex:startIndex, maxSize:maxSize, type:type }));
    }

    /**
     * 获取安全检查详情列表
     * orgCode:String, eaAreaCode:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetSecuritycheckListByEaAreaCodeOrOrgCode(orgCode, eaAreaCode, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetSecuritycheckListByEaAreaCodeOrOrgCode', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取安全检查列表
     * eaAreaCode:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetSecuritycheckCardListByEaAreaCode(eaAreaCode, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetSecuritycheckCardListByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取物业企业基础信息列表
     * orgName:String, startIndex:int, maxSize:int
     */
    GetBasicInformationList(orgName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetBasicInformationList', Qs.stringify({ orgName:orgName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取业委会秘书良好或不良好信息列表
     * name:String, eaAreaName:String, type:int, startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBehaviorListBySecretary(name, eaAreaName, type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorListBySecretary', Qs.stringify({ name:name, eaAreaName:eaAreaName, type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 查询公开信息列表(物业详情一级)
     * eaAreaCode:String, year:String, type:int
     */
    GetPublicReportFillListByEaArea(eaAreaCode, year, type){
        return request.post(this.baseurl + 'GetPublicReportFillListByEaArea', Qs.stringify({ eaAreaCode:eaAreaCode, year:year, type:type }));
    }

    /**
     * 获取信息报表公开列表
     * eaAreaCode:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetPublicReportFillListByEaAreaCode(eaAreaCode, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetPublicReportFillListByEaAreaCode', Qs.stringify({ eaAreaCode:eaAreaCode, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取业主基础信息详情
     * eaAreaCode:String
     */
    GetBasicDetailByOwner(type,secretaryName,eaAreaCode){
        return request.post(this.baseurl + 'GetBasicDetailByOwner', Qs.stringify({ type,secretaryName,eaAreaCode:eaAreaCode }));
    }

    /**
     * 获取信息公开详情列表
     * orgCode:String, eaAreaCode:String, date:Date, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetPublicInfoListByEaAreaCodeOrOrgCode(orgCode, eaAreaCode, date, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetPublicInfoListByEaAreaCodeOrOrgCode', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, date:date, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取负责人良好或不良好信息详情
     * eaAreaCode:String, type:int
     */
    GetBehaviorDetailByManger(eaAreaCode, type){
        return request.post(this.baseurl + 'GetBehaviorDetailByManger', Qs.stringify({ eaAreaCode:eaAreaCode, type:type }));
    }

    /**
     * 获取项目经理基础信息列表
     * eaAreaName:String, manageName:String, startIndex:int, maxSize:int
     */
    GetManageBaseInfoList(eaAreaName, manageName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetManageBaseInfoList', Qs.stringify({ eaAreaName:eaAreaName, manageName:manageName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取在管面积，在管数量详情列表
     * orgCode:String, eaAreaCode:String, type:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetEaAreaInfoListByEaAreaCodeOrOrgCode(orgCode, eaAreaCode, type, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetEaAreaInfoListByEaAreaCodeOrOrgCode', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, type:type, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取业委会主任基础信息详情
     * eaAreaCode:String
     */
    GetOwnerTeamMasterBaseInfo(eaAreaCode){
        return request.post(this.baseurl + 'GetOwnerTeamMasterBaseInfo', Qs.stringify({ eaAreaCode:eaAreaCode }));
    }

    /**
     * 获取业主评价物业区域业主反馈率详情
     * eaAreaCode:String, evaluateObjType:int
     */
    GetEvaluateResRateDetail(eaAreaCode, evaluateObjType){
        return request.post(this.baseurl + 'GetEvaluateResRateDetail', Qs.stringify({ eaAreaCode:eaAreaCode, evaluateObjType:evaluateObjType }));
    }

    /**
     * 获取业主良好或不良好信息列表
     * type:int, startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBehaviorListByOwner(type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorListByOwner', Qs.stringify({ type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 获取通知列表
     * nickName:String, eaAreaCode:String, endTime:Date, title:String, startIndex:int, maxSize:int
     */
    GetWeChatNoticeMsgList(nickName, eaAreaCode, endTime, title, startIndex, maxSize){
        return request.post(this.baseurl + 'GetWeChatNoticeMsgList', Qs.stringify({ nickName:nickName, eaAreaCode:eaAreaCode, endTime:endTime, title:title, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取主任良好或不良好信息详情
     * eaAreaCode:String, type:int
     */
    GetBehaviorDetailByDirector(eaAreaCode, type){
        return request.post(this.baseurl + 'GetBehaviorDetailByDirector', Qs.stringify({ eaAreaCode:eaAreaCode, type:type }));
    }

    /**
     * 获取物业企业基础信息详情
     * orgCode:String
     */
    GetBasicInformation(orgCode){
        return request.post(this.baseurl + 'GetBasicInformation', Qs.stringify({ orgCode:orgCode }));
    }

    /**
     * 获取业委会秘书良好或不良好信息详情
     * keyID:String, type:int
     */
    GetBehaviorDetailBySecretary(keyID, type){
        return request.post(this.baseurl + 'GetBehaviorDetailBySecretary', Qs.stringify({ keyID:keyID, type:type }));
    }

    /**
     * 获取业主基础信息列表
     * startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBasicListByOwner(startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBasicListByOwner', Qs.stringify({ startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 获取企业良好信息详情
     * orgCode:String, type:int
     */
    GetBehaviorDetail(orgCode, type){
        return request.post(this.baseurl + 'GetBehaviorDetail', Qs.stringify({ orgCode:orgCode, type:type }));
    }

    /**
     * 获取企业项目经理通知公告情况
     * orgCode:String, endTime:Date, startIndex:int, maxSize:int
     */
    GetCreditInfoOfPersonNoticeList(orgCode, endTime, startIndex, maxSize){
        return request.post(this.baseurl + 'GetCreditInfoOfPersonNoticeList', Qs.stringify({ orgCode:orgCode, endTime:endTime, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取企业良好信息列表
     * orgName:String, type:int, startIndex:int, maxSize:int, resultCount:boolean
     */
    GetBehaviorList(orgName, type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorList', Qs.stringify({ orgName:orgName, type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }

    /**
     * 获取业主良好或不良好信息详情
     * name:String, IDCard:String, eaAreaCode:String, type:int
     */
    GetBehaviorDetailByOwner(name, IDCard, eaAreaCode, type){
        return request.post(this.baseurl + 'GetBehaviorDetailByOwner', Qs.stringify({ name:name, IDCard:IDCard, eaAreaCode:eaAreaCode, type:type }));
    }

    /**
     * 获取良好行为列表
     * eaAreaCode:String, orgCode:String, name:String, iDCard:String, type:int, option:int, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetGoodBehaviorListByDetail(eaAreaCode, orgCode, name, iDCard, type, option, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetGoodBehaviorListByDetail', Qs.stringify({ eaAreaCode:eaAreaCode, orgCode:orgCode, name:name, iDCard:iDCard, type:type, option:option, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取业委会主任基础信息列表
     * eaAreaName:String, masterName:String, startIndex:int, maxSize:int
     */
    GetOwnerTeamMasterBaseInfoList(eaAreaName, masterName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetOwnerTeamMasterBaseInfoList', Qs.stringify({ eaAreaName:eaAreaName, masterName:masterName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取评价详情
     * keyId:String
     */
    GetEvaluateDetial(keyId){
        return request.post(this.baseurl + 'GetEvaluateDetial', Qs.stringify({ keyId:keyId }));
    }

      /**
     * 获取物业区域评价记录列表
     * orgCode:String, eaAreaCode:String, year:int, month:int, scored:boolean, evaluateObjType:int, startIndex:int, maxSize:int
     */
    GetEaAreaEvaluateRecordList(orgCode, eaAreaCode, year, month, scored, evaluateObjType, startIndex, maxSize){
        return request.post(this.baseurl + 'GetEaAreaEvaluateRecordList', Qs.stringify({ orgCode:orgCode, eaAreaCode:eaAreaCode, year:year, month:month, scored:scored, evaluateObjType:evaluateObjType, startIndex:startIndex, maxSize:maxSize }));
    }

     /**
     * 获取评价记录列表
     * stars:String, orgCode:String, eaAreaCode:String, year:int, month:int, evaluateObjType:int, startIndex:int, maxSize:int
     */
    GetEvaluateRecordList(stars, orgCode, eaAreaCode, year, month, evaluateObjType, startIndex, maxSize){
        return request.post(this.baseurl + 'GetEvaluateRecordList', Qs.stringify({ stars:stars, orgCode:orgCode, eaAreaCode:eaAreaCode, year:year, month:month, evaluateObjType:evaluateObjType, startIndex:startIndex, maxSize:maxSize }));
    }
    /**
     * 获取业委会监事良好或不良好信息列表
     * String peopleName, String eaAreaName, int type, int startIndex, int maxSize, boolean resultCount
     */
     GetBehaviorListBySupervisor(peopleName, eaAreaName, type, startIndex, maxSize, resultCount){
        return request.post(this.baseurl + 'GetBehaviorListBySupervisor', Qs.stringify({ peopleName:peopleName, eaAreaName:eaAreaName, type:type, startIndex:startIndex, maxSize:maxSize, resultCount:resultCount }));
    }
     /**
     * 获取业委会监事基础信息详情列表
     * int startIndex, int maxSize, boolean resultCount, String eaAreaName,String peopleName
     */
    GetBasicListBySupervisor(startIndex, maxSize, resultCount, eaAreaName, peopleName){
        return request.post(this.baseurl + 'GetBasicListBySupervisor', Qs.stringify({ startIndex:startIndex, maxSize:maxSize, resultCount:resultCount, eaAreaName:eaAreaName, peopleName:peopleName }));
    }
    newGetBasicInformation( orgCode){
        return request.post(this.baseurl + 'newGetBasicInformation', Qs.stringify({  orgCode }));
    }
    newGetManageBaseInfo( uniqId){
        return request.post(this.baseurl + 'newGetManageBaseInfo', Qs.stringify({  uniqId }));
    }
    newGetOwnerTeamMasterBaseInfo( uniqId){
        return request.post(this.baseurl + 'newGetOwnerTeamMasterBaseInfo', Qs.stringify({  uniqId }));
    }

}